<template>
  <!--Buttons for existing transactions-->
  <el-col :span="12" class="h-padded right-aligned-col" v-if="status">
    <span v-if="!isBalanced" class="unbalanced-tag">
      Unbalanced
    </span>
    <span
      v-else-if="['POSTED', 'CLOSED'].includes(status) && amountHasChanged && transactionType.name === 'je'"
      class="unbalanced-tag">
      Debits/Credits must equal original Posted amount when changing Distribution Lines
    </span>
    <el-button
      stye="font-size: 13px;"
      :disabled="!(isBalanced && saveOnlyStatuses && saveOnlyStatuses.includes(status))"
      @click="() => otherActions('uploadDocument')">
      Files {{ numberOfFiles ? `(${numberOfFiles})` : '' }}
    </el-button>
    <el-button type="warning" plain @click="$emit('convertToAP', false)" v-if="transactionType.name === 'po' && status === 'POSTED'" :disabled="converted_to_ap">
      Convert To AP
    </el-button>
    <el-dropdown
      v-if="transactionType.name === 'po' && ['DRAFT', 'OPEN', 'POSTED', 'CLOSED', 'VOIDED'].includes(status)"
      split-button
      type="default"
      :disabled="isSaving"
      @command='otherActions'>
      Other Actions
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          command="printpo">
          Print PO
        </el-dropdown-item>
        <el-dropdown-item
           command="emailpo">
           Email PO
         </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-button type="warning" plain @click="$emit('goBack', false)" :disabled="isSaving">
      Back
    </el-button>
    <el-dropdown
      v-if="transactionType.name !== 'po'"
      split-button
      type="default"
      :disabled="isSaving"
      @command='otherActions'>
      Other Actions
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          :disabled="!(isBalanced)"
          command="duplicateTransaction">
          Duplicate Transaction
        </el-dropdown-item>
        <el-dropdown-item
          :disabled="disableDistChanges"
          command="toggleDistChanges">
          {{ ['DRAFT', 'OPEN', 'AUDITED'].includes(status) ? 'Disable' : 'Enable' }} Distribution Changes
        </el-dropdown-item>
        <el-dropdown-item
          v-if="transactionType.name === 'pc'"
          :disabled="!(isBalanced && Number(parentForm.reimbursed_amount_decimal) === 0 && saveOnlyStatuses.includes(status))"
          command="reimbursePcVendor">
          Create A/P Reimbursement Invoice
        </el-dropdown-item>
        <el-dropdown-item
          v-if="status === 'POSTED' && !isPaid "
          :disabled="isRecon"
          command="void">
          Void
        </el-dropdown-item>
        <el-dropdown-item
          v-if="allowDeleteStatuses.includes(status)"
          :disabled="isRecon"
          command="delete">
          Delete
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-button
      v-if="status !== 'DRAFT'"
      @click="$emit('addNew')"
      :disabled="isSaving"
      icon="plus"
    />
    <el-button
      v-if="status === 'DRAFT' && !isBalanced"
      :disabled="!hasBeenChanged || !isSaveable"
      type="primary"
      :loading="isSaving"
      @click="handleDropdownClick('1')">
      Save Draft
    </el-button>
    <el-button
      v-else-if="status === 'DRAFT' && isBalanced"
      :disabled="!isSaveable"
      type="primary"
      :loading="isSaving"
      @click="handleDropdownClick('1')">
      {{ hasBeenChanged ? 'Save' : 'Open' }}
    </el-button>
    <el-dropdown
      split-button
      type="primary"
      v-if="hasBeenChanged && !dropdownStatuses.includes(status) && !isSaving && isBalanced && isSaveable"
      @command='handleDropdownClick'
      @click="hasBeenChanged && status === 'AUDITED' ? handleDropdownClick('2') : handleDropdownClick('1')"
      trigger="click">
      Save
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-if="saveAndAuditStatuses.includes(status)" command="3">
          Save + Audit
        </el-dropdown-item>
        <el-dropdown-item v-if="saveAndPostStatuses.includes(status) && checkIfUserHasRequiredPermissions(['auth.has_scope_post'])" command="4">
          Save + Post
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-button
      v-else-if="hasBeenChanged && !dropdownStatuses.includes(status) && isBalanced && isSaving"
      type="primary"
      :loading="isSaving">
      Saving
    </el-button>
    <el-button
      v-else-if="saveOnlyStatuses.includes(status)"
      :disabled="!(hasBeenChanged && isBalanced && isSaveable) || isSaving"
      :loading="isSaving"
      type="primary"
      @click="handleDropdownClick('1')">
      Save
    </el-button>
    <el-button
      v-if="['OPEN', 'AUDITED'].includes(status) && !hasBeenChanged"
      type="success"
      :disabled="!isBalanced || disableAuditBtn"
      :loading="disableAuditBtn"
      @click="$emit('auditBtnClick')">
      Audit
    </el-button>
    <el-button
      v-if="postBtnStatuses.includes(status) && !hasBeenChanged && checkIfUserHasRequiredPermissions(['auth.has_scope_post'])"
      type="success"
      :disabled="!isBalanced || disableAuditBtn"
      :loading="disablePostBtn"
      @click="$emit('postBtnClick')">
      Post
    </el-button>
    <el-button
      v-if="transactionType.name === 'ar' && status  === 'POSTED'"
      type="primary"
      :loading="printingOnly"
      @click="$emit('postBtnClick')">
      {{ printingOnly ? 'Printing' : 'Print Copy' }}
    </el-button>
  </el-col>
  <!--Buttons for new transactions-->
  <el-col :span="isSaveable && isSaving ? 6 : 12" class="h-padded right-aligned-col" v-else>
    <span v-if="!isBalanced" class="unbalanced-tag">
      Unbalanced
    </span>
    <el-button type="warning" plain @click="$emit('goBack', false)" :disabled="isSaving">
      Back
    </el-button>
    <el-button
      v-if="!isOpenable"
      type="primary"
      :disabled="!isSaveable"
      :loading="isSaving"
      @click="$emit('submit', false)">
      Save as Draft
    </el-button>
    <el-dropdown
      v-else-if="isSaveable && isOpenable && !isSaving"
      id="save-action-dropdown"
      type="primary"
      split-button
      @command='handleDropdownClick'
      @click="defaultSaveClick()"
      trigger="click">
      Save
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="2">Save as Draft</el-dropdown-item>
        <el-dropdown-item command="3">Save & Add New</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-button
      v-else-if="isSaveable && isOpenable && isSaving"
      type="primary"
      :loading="isSaving">
      Saving
    </el-button>
  </el-col>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      status: String,
      converted_to_ap: Boolean,
      isSaving: Boolean,
      isSaveable: Boolean,
      isOpenable: Boolean,
      isReadOnly: Boolean,
      isBalanced: Boolean,
      hasBeenChanged: Boolean,
      amountHasChanged: Boolean,
      transactionType: Object,
      parentForm: Object,
      numberOfFiles: Number,
      isPaid: Boolean,
      isRecon: {
        default: false,
        type: Boolean
      },
      dropdownStatuses: {
        default: () => ['DRAFT', 'CLOSED', 'POSTED', 'VOIDED'],
        type: Array
      },
      saveAndAuditStatuses: {
        default: () => ['OPEN', 'AUDITED'],
        type: Array
      },
      saveAndPostStatuses: {
        default: () => ['OPEN', 'AUDITED'],
        type: Array
      },
      saveOnlyStatuses: {
        default: () => ['POSTED', 'OPEN', 'AUDITED', 'CLOSED'],
        type: Array
      },
      allowDeleteStatuses: {
        default: () => ['DRAFT', 'OPEN'],
        type: Array
      },
      disableDistChanges: {
        default: false,
        type: Boolean
      },
      disableAuditBtn: {
        default: false,
        type: Boolean
      },
      disablePostBtn: {
        default: false,
        type: Boolean
      },
      printingOnly: {
        default: false,
        type: Boolean
      },
      postBtnStatuses: {
        default: () => ['OPEN', 'AUDITED'],
        type: Array
      }
    },
    methods: {
      defaultSaveClick () {
        let actionNumber = '1'
        if (this.addAnotherByDefault) {
          actionNumber = '3'
        }
        this.handleDropdownClick(actionNumber)
      },
      handleDropdownClick (val) {
        this.$emit('dropdownClick', val)
      },
      otherActions (val) {
        this.$emit('otherActions', val)
      }
    },
    computed: {
      ...mapGetters({ checkIfUserHasRequiredPermissions: 'checkIfUserHasRequiredPermissions' }),
      addAnotherByDefault () {
        this.$store.dispatch('fetchUiSetting', { name: 'ADD_ANOTHER_TRANSACTION_BY_DEFAULT' })
        return !!this.$store.getters.getUiSettings['ADD_ANOTHER_TRANSACTION_BY_DEFAULT']
      }
    }
  }
</script>

<style scoped>
  .el-button {
    margin: 0;
  }
  .right-aligned-col {
    text-align: right;
  }
  .unbalanced-tag {
    margin: 0 12px;
    background-color: rgba(255,73,73,.1);
    border: 1px solid rgba(255,73,73,.2);
    display: inline-block;
    color: #ff4949;
    padding: 0 5px;
    height: 24px;
    line-height: 22px;
    font-size: 12px;
    border-radius: 4px;
    box-sizing: border-box;
  }
  .el-dropdown-menu__item {
    min-width: 8.4rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/DataEntryButtons.vue